// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.srprs-modalHeader {
  --padding: section(padding-initial);
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 48px;
  padding-right: 20px;
  padding-left: 20px;
  font-weight: bold;
  font-size: 15px;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
}
.srprs-modalHeader:before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 20px;
  width: calc(100% - var(--padding) * 2);
  height: 1px;
  background-color: #e7e7e7;
}
.srprs-modalHeader:after {
  content: "";
  position: absolute;
  left: var(--padding);
  width: calc(100% - var(--padding) * 2);
  height: var(--padding);
  bottom: calc(0px - var(--padding));
  z-index: 2;
  background-image: linear-gradient(to bottom, white 0%, rgba(255, 255, 255, 0) 100%);
}
.srprs-modalHeader + .content {
  margin-top: 48px;
  max-height: calc(100% - 128px);
}
.srprs-modalHeader .icon {
  display: none;
}
.srprs-modalHeader .srprs-icon svg path {
  fill: #222;
}
.srprs-modalHeader .type-textlink-uppercase span {
  font-weight: lighter;
}
.srprs-modalHeader .type-textlink-uppercase:hover {
  transform: none;
}
.srprs-modalHeader .title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-top: 5px;
  display: inline-block;
  width: calc(100% - 36px);
  text-transform: uppercase;
  user-select: none;
}
.srprs-modalHeader .title span {
  font-weight: normal;
}
.srprs-modalHeader .close {
  cursor: pointer;
  position: absolute;
  right: var(--padding);
  top: 60%;
  transform: translateY(-50%);
}
.srprs-modalHeader .close .srprs-icon {
  bottom: 0;
}
.srprs-modalHeader .srprs-button:first-child {
  margin-top: 5px;
}
.srprs-modalHeader .srprs-button:first-child:hover .srprs-icon {
  transform: translate(-2px, 5px);
}
.srprs-modalHeader .srprs-button:first-child .srprs-icon {
  transform: translateY(5px);
  margin-right: 4px;
  width: 16px;
  height: 16px;
}
.srprs-modalHeader .srprs-button:first-child + .title {
  position: relative;
  margin-left: 8px;
  padding-left: 9px; /* 8px + 1px for &:before which is below */
  width: calc(100% - 90px);
}
.srprs-modalHeader .srprs-button:first-child + .title:before {
  content: "";
  position: absolute;
  top: -2px;
  left: 0;
  width: 1px;
  height: calc(100% + 4px);
  background-color: #e7e7e7;
}

@media screen and (min-width: 768px) {
  .srprs-modalHeader {
    height: 76px;
    padding: 24px 36px;
  }
  .srprs-modalHeader:before {
    display: none;
  }
  .srprs-modalHeader + .content {
    margin-top: 76px;
  }
  .srprs-modalHeader .icon {
    display: block;
  }
  .srprs-modalHeader .icon .srprs-icon {
    width: 1.25em;
    height: 1.25em;
  }
  .srprs-modalHeader .title {
    position: relative;
    width: calc(100% - 72px);
    margin-left: 8px;
    padding-left: 9px; /* 8px + 1px for &:before which is below */
    font-weight: bold;
    font-size: 16px;
  }
  .srprs-modalHeader .title:before {
    content: "";
    position: absolute;
    top: -2px;
    left: 0;
    width: 1px;
    height: calc(100% + 4px);
    background-color: #e7e7e7;
  }
  .srprs-modalHeader .close {
    right: 36px;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/Modal/ModalHeader.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_truncate.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AArMA;EACE,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EAEE,mBAAA;EACA,kBAAA;EAGA,iBAAA;EACA,eAAA;EAIE,4BAAA;EACA,2BAAA;AAiMN;AA9LE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,sCAAA;EACA,WAAA;EAEE,yBAAA;AA+LN;AA5LE;EACE,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,sCAAA;EACA,sBAAA;EACA,kCAAA;EACA,UAAA;EAEE,mFAAA;AA6LN;AAtLE;EAEI,gBAAA;EAEF,8BAAA;AAsLJ;AApLE;EACE,aAAA;AAsLJ;AAlLM;EACE,UAAA;AAoLR;AA/KI;EAEI,oBAAA;AAgLR;AA7KI;EACE,eAAA;AA+KN;AA5KE;EI9EA,gBAAA;EACA,mBAAA;EACA,uBAAA;EJ8EE,gBAAA;EACA,qBAAA;EACA,wBAAA;EAEE,yBAAA;EAEF,iBAAA;AA8KJ;AA7KI;EAEI,mBAAA;AA8KR;AA1KE;EACE,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,2BAAA;AA4KJ;AA3KI;EACE,SAAA;AA6KN;AA1KE;EAEI,eAAA;AA2KN;AAxKI;EACE,+BAAA;AA0KN;AAvKI;EACE,0BAAA;EAEE,iBAAA;EAEF,WAAA;EACA,YAAA;AAuKN;AApKI;EACE,kBAAA;EAEE,gBAAA;EAGA,iBAAA,EAAA,0CAAA;EAEF,wBAAA;AAkKN;AAhKM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,wBAAA;EAEE,yBAAA;AAiKV;;ACzSI;EDgJF;IACE,YAAA;IACA,kBAAA;EA6JF;EA5JE;IACE,aAAA;EA8JJ;EA5JE;IAEI,gBAAA;EA6JN;EA1JE;IACE,cAAA;EA4JJ;EA3JI;IACE,aAAA;IACA,cAAA;EA6JN;EA1JE;IACE,kBAAA;IACA,wBAAA;IAEE,gBAAA;IAGA,iBAAA,EAAA,0CAAA;IAGA,iBAAA;IACA,eAAA;EAuJN;EArJI;IACE,WAAA;IACA,kBAAA;IACA,SAAA;IACA,OAAA;IACA,UAAA;IACA,wBAAA;IAEE,yBAAA;EAsJR;EAlJE;IACE,WAAA;EAoJJ;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","@charset \"UTF-8\";\n\n@import '../_Assets/scss/core';\n\n.srprs-modalHeader {\n  --padding: section(padding-initial);\n  display: flex;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 48px;\n  padding: {\n    right: section(padding-initial);\n    left: section(padding-initial);\n  }\n  font: {\n    weight: bold;\n    size: 15px;\n  }\n  border: {\n    top: {\n      right-radius: 4px;\n      left-radius: 4px;\n    }\n  }\n  &:before {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: section(padding-initial);\n    width: calc(100% - (var(--padding) * 2));\n    height: 1px;\n    background: {\n      color: color(grey-light);\n    }\n  }\n  &:after {\n    content: '';\n    position: absolute;\n    left: var(--padding);\n    width: calc(100% - (var(--padding) * 2));\n    height: var(--padding);\n    bottom: calc(0px - var(--padding));\n    z-index: 2;\n    background: {\n      image: linear-gradient(\n        to bottom,\n        rgba(color(white), 1) 0%,\n        rgba(color(white), 0) 100%\n      );\n    }\n  }\n  & + .content {\n    margin: {\n      top: 48px;\n    }\n    max-height: calc(100% - 128px);\n  }\n  .icon {\n    display: none;\n  }\n  .srprs-icon {\n    svg {\n      path {\n        fill: color(black);\n      }\n    }\n  }\n  .type-textlink-uppercase {\n    span {\n      font: {\n        weight: lighter;\n      }\n    }\n    &:hover {\n      transform: none;\n    }\n  }\n  .title {\n    @include truncate();\n    padding-top: 5px;\n    display: inline-block;\n    width: calc(100% - 36px);\n    text: {\n      transform: uppercase;\n    }\n    user-select: none;\n    span {\n      font: {\n        weight: normal;\n      }\n    }\n  }\n  .close {\n    cursor: pointer;\n    position: absolute;\n    right: var(--padding);\n    top: 60%;\n    transform: translateY(-50%);\n    .srprs-icon {\n      bottom: 0;\n    }\n  }\n  .srprs-button:first-child {\n    margin: {\n      top: 5px;\n    }\n\n    &:hover .srprs-icon {\n      transform: translate(-2px, 5px);\n    }\n\n    .srprs-icon {\n      transform: translateY(5px);\n      margin: {\n        right: 4px;\n      }\n      width: 16px;\n      height: 16px;\n    }\n\n    & + .title {\n      position: relative;\n      margin: {\n        left: 8px;\n      }\n      padding: {\n        left: 9px; /* 8px + 1px for &:before which is below */\n      }\n      width: calc(100% - 90px);\n\n      &:before {\n        content: '';\n        position: absolute;\n        top: -2px;\n        left: 0;\n        width: 1px;\n        height: calc(100% + 4px);\n        background: {\n          color: color(grey-light);\n        }\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-portrait) {\n  .srprs-modalHeader {\n    height: 76px;\n    padding: 24px 36px;\n    &:before {\n      display: none;\n    }\n    & + .content {\n      margin: {\n        top: 76px;\n      }\n    }\n    .icon {\n      display: block;\n      .srprs-icon {\n        width: 1.25em;\n        height: 1.25em;\n      }\n    }\n    .title {\n      position: relative;\n      width: calc(100% - 72px);\n      margin: {\n        left: 8px;\n      }\n      padding: {\n        left: 9px; /* 8px + 1px for &:before which is below */\n      }\n      font: {\n        weight: bold;\n        size: 16px;\n      }\n      &:before {\n        content: '';\n        position: absolute;\n        top: -2px;\n        left: 0;\n        width: 1px;\n        height: calc(100% + 4px);\n        background: {\n          color: color(grey-light);\n        }\n      }\n    }\n    .close {\n      right: 36px;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n","@charset \"UTF-8\";\n\n@mixin truncate() {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
